interface CardGeometry {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface InsuranceMatchTile {
  id: string;
  src: string;
  mobileSrc: string;
  title: string;
  description: string;
  width: number;
  height: number;
  mobileWidth: number;
  mobileHeight: number;
  rotation: number;
  card: CardGeometry;
  mobileCard: CardGeometry;
}

export const INSURANCE_MATCH_TILES: InsuranceMatchTile[] = [
  {
    id: "tiers",
    src: "/assets/pack-zero-franchise/tier-tile.svg",
    mobileSrc: "/assets/pack-zero-franchise/tier-tile-mobile.svg",
    title: "Vous êtes assuré au tiers ?",
    description:
      "Même au tiers, bénéficiez d’un vrai soutien : on finance vos réparations jusqu’à 500 €.",
    width: 509,
    height: 311,
    mobileWidth: 352,
    mobileHeight: 280,
    rotation: -5,
    card: { left: 13.334, top: 76.4, width: 465, height: 216 },
    mobileCard: { left: 17.2031, top: 63.5889, width: 304, height: 197 },
  },
  {
    id: "zero-franchise",
    src: "/assets/pack-zero-franchise/zero-franchise-tile.svg",
    mobileSrc: "/assets/pack-zero-franchise/zero-franchise-tile-mobile.svg",
    title: "Vous avez l’option « Zéro Franchise » chez votre assureur ?",
    description:
      "Elle fait exploser votre assurance de 20 à 40%. On s’en occupe pour bien moins cher, la qualité et les services Roole en plus !",
    width: 510,
    height: 319,
    mobileWidth: 357,
    mobileHeight: 343,
    rotation: 5,
    card: { left: 32.858, top: 35.86, width: 465, height: 224 },
    mobileCard: { left: 36.813, top: 37.0938, width: 304, height: 261 },
  },
];
